<template>
  <div class="ly-inner">
    <idc-page-title :breadcrumbList="breadcrumbList">{{ pageTitle }}</idc-page-title>
    <table-filter v-if="!$isMobile()" @searchEquip="searchEquip"/>
    <table-data ref="tableDt"
      @goDetail="goDetail"
    />
  </div>
</template>

<script>
import IdcPageTitle from "@/components/common/IdcPageTitle";
import TableFilter from "@/components/helpDesk/TableFilter";
import TableData from "@/components/helpDesk/equipTkotTkinApy/TableData";
export default {
  components: {
    IdcPageTitle,
    TableFilter,
    TableData,
  },
  data() {
    return {
      title : this.$route.meta.title,
      navigator : this.$route.meta.navigator
    };
  },
  created() {
    this.title      = (this.i18n === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn;
    this.navigator  = (this.i18n === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn;
  },
  computed: {
    breadcrumbList() {
      return this.navigator;
    },
    pageTitle() {
      return this.title;
    },
    i18n() {
      return this.$i18n.locale;
    },
  },
  watch: {
    i18n(newVal) {
      this.title      = (newVal === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn
      this.navigator  = (newVal === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn
    }
  },
  methods: {
    searchEquip(data) {
      this.$refs.tableDt.tableData = [];
      for(let i=0;i<data.length;i++) {
        data.tkinIdcCd = data.vistIdcCd;
        data.tkinSttusCd = data.rsrvSttusCd;
        data.tkinrNm = data.vistrNm;
        data.tkinPamDt = data.virsDt;
      }
      this.$refs.tableDt.searchForm = data;
      this.$refs.tableDt.getOprEquipTkinApyList(1);
    },
    goDetail(row) {
      if(this.$isMobile()) {
        this.$router.push({
          path: "/helpDesk/equipTkotTkinApyDetailMobile" ,
          query: { equipTkinApyId : row.equipTkinApyId, tkinTkotDiv : row.tkinTkotDiv }
        })
      } else {
        let url = this.$router.resolve({
          path: "/helpDesk/equipTkotTkinApyDetail" ,
          query: { equipTkinApyId : row.equipTkinApyId, tkinTkotDiv : row.tkinTkotDiv }
        }).href
        window.open(url, "_blank", "width=1300,height=800,noopener, noreferrer")
      }
    }
  },
  
};
</script>

<style lang="scss" scoped>
.ly-table {
  //삭제
  .ly-title {
    padding-bottom: 10px;
  }
  .el-form {
    border-top: 1px solid $--color-light-gray;
    &-item {
      margin-bottom: 0;
      &__label {
        text-align: left; ///////////////
        padding: 0 10px;
        line-height: 40px;
        border: {
          right: 1px solid $--color-light-gray;
          left: 1px solid $--color-light-gray;
        }
        background-color: $--color-white-smoke;
      }
    }
  }
  .el-row {
    border-bottom: 1px solid $--color-light-gray;
    .el-col {
      &:first-child {
        .el-form-item__label {
          border-left: 0;
        }
      }
    }
  }
}

.ly-inner {
  text-align: left;
}
.el-pagination {
  margin-top: 20px;
}

.table {
  &-header {
    text-align: left;
    padding-bottom: 20px;
  }
  &-title {
    font-size: $--font-size-large;
    color: $--color-black;
    font-weight: $--font-weight-bold;
  }
  &-count {
    text-align: left;
    font-size: $--font-size-base;
    margin-bottom: 10px;
    span {
      font-weight: $--font-weight-bold;
    }
  }
  &-block {
    padding-top: 20px;
    &:not(:last-child) {
      padding-bottom: 40px;
    }
  }
  &-option {
    gap: 5px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
